const PopupTypeEnum = {
	None: 'none',
	CreateFile: 'createFile',
	CreateLink: 'createLink',
	CreateNav: 'createNav',
};

export default PopupTypeEnum;
